import { render, staticRenderFns } from "./TourAdd.vue?vue&type=template&id=395296ce"
import script from "./TourAdd.vue?vue&type=script&lang=js"
export * from "./TourAdd.vue?vue&type=script&lang=js"
import style0 from "./TourAdd.vue?vue&type=style&index=0&id=395296ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports